export default "__VITE_ASSET__kEyttEF1__"